export interface CreateAddressModalState {
  isOpen: boolean;
}

export const createAddressModalInitialState: CreateAddressModalState = {
  isOpen: false
};
